<template>
  <div class="lg:flex lg:flex-row-reverse px-4 mb-20 lg:mb-40">
    <div class="w-full lg:w-[651px] mb-6 lg:mb-0">
      <div>
        <div class="text-title text__headline-4-xs--bold lg:text__headline-3-md--bold">
          {{ qualityPrice.title }}
        </div>
      </div>
      <div class="mt-4 lg:mt-6">
        <div class="text-body-1 text__body-2--md--regular" v-html="qualityPrice.description" />
      </div>
    </div>
    <div class="mx-auto flex justify-center mr-14">
      <img
        data-src="@images/public/how-it-work/quality-price.png"
        class="lazyload mx-auto w-full lg:w-auto lg:h-[353px]"
      >
    </div>
  </div>
</template>
<script>
import staticData from './static-data'

export default {
  name: 'QualityPrice',
  data () {
    return {
      qualityPrice: staticData.component.QualityPrice
    }
  }
}
</script>
